import styled from 'styled-components';
import { Table } from 'ui/table';
import { TableCell } from 'ui/tableCell';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { PaginationFooter } from 'ui/paginationFooter';
import { borderRadius, button, caption, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const MessageTypesTable = styled(Table)`
  border-collapse: separate;

  & > div:last-of-type > div {
    border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
  }
`;

export const MessageTypesTableHeader = styled(TableHeader)`
  & > div {
    border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
    border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
    padding: ${spacing.base};
  }

  & > div:first-of-type {
    border-left: ${spacing.single} solid ${colors.borderPrimarySubtle};
    border-top-left-radius: ${borderRadius.lg};
  }

  & > div:last-of-type {
    border-right: ${spacing.single} solid ${colors.borderPrimarySubtle};
    border-top-right-radius: ${borderRadius.lg};
  }

  & > div:not(:first-of-type) > div {
    justify-content: flex-end;
  }
`;

export const MessageTypeUnsubscribeHeader = styled.span`
  ${button};
  color: inherit;
  gap: ${spacing.quarter};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MessageTypesTableRows = styled(TableRows)`
  & {
    height: ${pxToRem(64)};
  }

  & > div {
    vertical-align: middle;
  }

  & > div:first-of-type {
    border-left: ${spacing.single} solid ${colors.borderPrimarySubtle};
  }

  & > div:last-of-type {
    border-right: ${spacing.single} solid ${colors.borderPrimarySubtle};
  }
`;

export const MessageTypeHeaderCell = styled(TableCell)`
  padding: ${spacing.base};
`;
export const RightAlignedMessageTypeHeaderCell = styled(MessageTypeHeaderCell)`
  text-align: end;
`;

export const StyledPageFooter = styled(PaginationFooter)`
  padding: ${spacing.base} ${spacing.double};
  border: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-top: none;
  border-bottom-left-radius: ${borderRadius.lg};
  border-bottom-right-radius: ${borderRadius.lg};

  & > fieldset {
    display: flex;
    align-items: center;
    gap: ${spacing.half};
  }

  & > fieldset::before {
    ${caption};
    color: ${colors.textSecondary};
    content: 'Items per page';
    position: relative;
    bottom: ${spacing.single};
  }
`;
